import styled from 'styled-components'

import NavLink from './Link'

const BrandLink = styled(NavLink)`
  &::before {
    height: 0;
  }
`

export default BrandLink
